
























































import Vue, { VueConstructor } from "vue";
import { LicenseData } from "@/models/license";
import validationMixin from "@/components/mixins/validationMixin";
import VaButton from "@/components/atoms/VaButton.vue";
import LicenseService from "@/services/licenseService";
import onPremService from "@/services/onPremService";

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof validationMixin>>
).extend({
  name: "NewLicense",
  mixins: [validationMixin],
  components: {
    VaButton,
  },
  async beforeMount() {
    this.$store.commit("license/resetCurrentLicense");
  },
  data() {
    return {
      newLicense: {
        licenseKey: "",
        isRenewal: false,
      } as LicenseData,
      fileLicense: undefined as File | undefined,
    };
  },
  methods: {
    onDismiss(): void {
      this.$emit("onDismiss");
    },
    onFinish(): void {
      this.$emit("onFinish", this.newLicense);
    },
    async onUpload(): Promise<void> {
      if (this.fileLicense) {
        const r = (await onPremService.uploadLicense(this.fileLicense)) as any;
        const res = await LicenseService.getLicense(r.data as string);

        const licenseDetail = {
          key: res.key,
          licensePackageId: res.id,
          name: res.name,
          sku: res.sku,
          status: res.status,
          creationDate: res.creationDate,
          expirationDate: res.expirationDate,
          isRoom: res.isPod,
          activations: res.activations,
          users: res.detailUsers,
          isPod: res.isPod,
        };
        this.$emit("onFinish", licenseDetail);
        this.fileLicense = undefined;
      }
    },

    async onSave(): Promise<void> {
      if (
        (
          this.$refs.newLicenseForm as Vue & { validate: () => boolean }
        ).validate()
      ) {
        const addlicense = await this.$store.dispatch(
          "license/addLicense",
          this.newLicense
        );
        // const addlicense = await LicenseService.post(this.newLicense);
        if (addlicense) {
          const res = await LicenseService.getLicense(
            this.newLicense.licenseKey
          );
          const licenseDetail = {
            key: res.key,
            licensePackageId: res.licensePackageId,
            name: res.name,
            sku: res.sku,
            status: res.status,
            creationDate: res.creationDate,
            expirationDate: res.expirationDate,
            isRoom: res.isPod,
            activations: res.activations,
            users: res.detailUsers,
            isPod: res.isPod,
          };
          this.$emit("onFinish", licenseDetail);
        }
      }
    },
  },
  computed: {
    isOnPrem(): boolean {
      return this.$store.getters["onprem/isOnPrem"];
    },
  },
});
